/**
 * Visible text from the element's immediate context — its own text plus
 * the previous and next siblings. Useful for agents that need to
 * disambiguate similar buttons (e.g. multiple "Submit" forms on the page).
 */
const truncate = (s, n = 200) => s.length > n ? `${s.slice(0, n - 1)}…` : s;
const visible = (el) => {
    if (!el)
        return "";
    return (el.textContent ?? "").trim().replace(/\s+/g, " ");
};
export const getNearbyText = (el, maxChars = 200) => {
    const parts = [];
    const before = el.previousElementSibling;
    const after = el.nextElementSibling;
    const beforeText = visible(before);
    const selfText = visible(el);
    const afterText = visible(after);
    if (beforeText)
        parts.push(`«${truncate(beforeText, 80)}»`);
    if (selfText)
        parts.push(selfText);
    if (afterText)
        parts.push(`«${truncate(afterText, 80)}»`);
    return truncate(parts.join(" "), maxChars);
};
/**
 * Compact summary of the surrounding DOM tree — useful for the AFS
 * `nearbyElements` field. Captures the parent's direct children with
 * their tag + first stable class.
 */
export const getNearbyElements = (el) => {
    const parent = el.parentElement;
    if (!parent)
        return "";
    const list = [];
    for (const sibling of Array.from(parent.children)) {
        const tag = sibling.tagName.toLowerCase();
        const cls = Array.from(sibling.classList).slice(0, 1).join(".");
        const marker = sibling === el ? "→" : " ";
        list.push(`${marker} ${tag}${cls ? "." + cls : ""}`);
    }
    return list.join("\n");
};
//# sourceMappingURL=nearbyText.js.map